// Permissões granulares do usuário logado, a partir do user_ow (preenchido pelo
// Layout com o /user-permissions/me). Só usabilidade: quem barra é o back.

function currentUser() {
	try {
		return JSON.parse(localStorage.getItem("user_ow") || "{}");
	} catch {
		return {};
	}
}

/**
 * O usuário pode `permission` (ex.: "project_hours:approve")? Com `resourceId`,
 * naquele recurso (ex.: o projeto); sem ele, em qualquer um. ADM pode tudo.
 */
export function hasPermission(permission, resourceId) {
	const user = currentUser();
	if (user.role === "ADM") return true;

	const scope = user.scopes?.[permission];
	// user_ow gravado antes dos scopes: só dá para saber se a string existe
	if (!scope) return !user.scopes && (user.permissions || []).includes(permission);
	if (scope.all) return true;
	if (resourceId === undefined || resourceId === null) return (scope.ids || []).length > 0;
	return (scope.ids || []).includes(Number(resourceId));
}
